import React from 'react';
import Modal from './Modal';
import './ExportFormatModal.css';

/**
 * Modal to choose export format: GPX or Raw GeoJSON.
 * Props: isOpen, onClose, onSelectFormat('gpx' | 'geojson'), disabled (e.g. while exporting), gpxDisabled (optional, e.g. when time range invalid)
 */
const ExportFormatModal = ({ isOpen, onClose, onSelectFormat, disabled = false, gpxDisabled = false }) => {
  const handleSelect = (format) => {
    if (disabled) return;
    if (format === 'gpx' && gpxDisabled) return;
    onSelectFormat(format);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Export format" className="export-format-modal">
      <div className="export-format-options">
        <button
          type="button"
          className="export-format-option"
          onClick={() => handleSelect('gpx')}
          disabled={disabled || gpxDisabled}
          title={gpxDisabled ? 'Set start and end time first' : null}
        >
          <span className="export-format-option-title">GPX</span>
          <span className="export-format-option-subtitle">
            For iOS location mocking through Xcode. Contains only lat, lon, alt.
            {gpxDisabled && ' Set start/end range above first.'}
          </span>
        </button>
        <button
          type="button"
          className="export-format-option"
          onClick={() => handleSelect('geojson')}
          disabled={disabled}
        >
          <span className="export-format-option-title">Raw GeoJSON</span>
          <span className="export-format-option-subtitle">
            Contains stats, detected runs (if available), and raw telemetry (consolidated).
          </span>
        </button>
      </div>
    </Modal>
  );
};

export default ExportFormatModal;
